import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-product-master-group-list',
  templateUrl: './product-master-group-list.component.html',
  styleUrls: ['./product-master-group-list.component.css']
})
export class ProductMasterGroupListComponent implements OnInit {

  productGroupList: any = []
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage: number = 10;
  searchKey: any = ""
  tableSizes: any = [3, 6, 9, 12];
  first: number = 0;
  isLoading: any = false
  form: any | FormGroup
  cid: any
  formSubmit: boolean = false;
  productMasterGroupId: any = ""
  recordName: any = "";
  recordId: any = "";

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    this.getAllProductMasterGroupWithPagination(this.pageNumber, this.recordsPerPage)
    this.cid = sessionStorage.getItem('cid')
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      description: ['']
    })
  }

  remove() {
    this.form.reset()
  }

  addProductMasterGroup() {
    this.formSubmit = true;
    if (!this.form.valid) {
      this.toastr.error("Please fill in all required fields");
      return
    }
    let body = {
      "version": 0,
      "isActive": true,
      "description": this.form.get('description').value,
      "productMasterGroupId": 0,
      "name": this.form.get('name').value,
      "cid": this.cid,
    }

    this.generic_service.addProductMasterGroup(body).subscribe(
      (response: any) => {
        this.formSubmit = false;
        this.form.reset()
        this.toastr.success(response.message);
      },
      (err: any) => {
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }


  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    this.recordsPerPage = event.rows;


    if (this.searchKey != "") {
      this.getAllProductMasterGroupByWildSearch(this.pageNumber, this.recordsPerPage)
    } else {
      this.getAllProductMasterGroupWithPagination(this.pageNumber, this.recordsPerPage);
    }
  }

  getAllProductMasterGroupByWildSearch(pageNumber: any, recordsPerPage: any) {

    if (this.searchKey != "") {
      this.isLoading = true

      this.generic_service.getAllProductMasterGroupByWildSearch(this.searchKey, pageNumber, recordsPerPage).subscribe(
        (response: any) => {
          console.log(response);

          this.productGroupList = response.response.productMasterGroupList
          this.totalRecords = response.response.totalRecords
          this.isLoading = false

        },
        (err: any) => {
          console.log(err)
        }
      )
    } else {
      this.getAllProductMasterGroupWithPagination(this.pageNumber, this.recordsPerPage)
    }

  }

  refreshSearch() {
    this.searchKey = ""
    this.getAllProductMasterGroupWithPagination(this.pageNumber, this.recordsPerPage)
  }

  getAllProductMasterGroupWithPagination(pageNumber: any, recordsPerPage: any) {
    this.isLoading = true
    this.generic_service.getAllProductMasterGroupWithPagination(pageNumber, recordsPerPage).subscribe(
      (response: any) => {
        console.log(response);
        this.productGroupList = response.response.productMasterGroupList
        this.totalRecords = response.response.totalRecords
        this.isLoading = false

      }
    )
  }

  // getAllProductMasterGroup(){
  // this.isLoading = true

  //   this.generic_service.getAllProductMasterGroup().subscribe(
  //     (res:any)=> {
  //       console.log(res)
  //       this.productGroupList = res.response
  //       this.totalRecords = res.response.length
  //       this.isLoading = false

  //     },
  //     (err:any)=>{
  //       console.log(err)
  //     }
  //   )
  // }

  getProductMasterGroupById(id: any) {
    this.generic_service.getProductMasterGroupById(id).subscribe(
      (res: any) => {

      }
    )
  }


  refreshAll() {
    this.pageNumber = 0
    this.searchKey = ""
    this.getAllProductMasterGroupWithPagination(this.pageNumber, this.recordsPerPage)
  }


  selectDelete(id: any, record: any) {
    this.productMasterGroupId = id;
    this.recordId = record.productMasterGroupId;
    this.recordName = record.name;
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click()
    document.getElementById("deleteModalButton")?.click()
  }

  deleteProductMasterGroup() {
    this.generic_service.deleteProductMasterGroup(this.productMasterGroupId).subscribe(
      (res: any) => {
        this.toastr.success("Successfully Deleted");
        this.getAllProductMasterGroupWithPagination(this.pageNumber, this.recordsPerPage)
        this.cancelModel();
      }, err => {
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }

}
